import { points, polygon, pointsWithinPolygon } from '@turf/turf';

export const getExistingFeaturesGeoJSON = ({ customer, customerGeoFencing }) => {
  return customerGeoFencing
    ? [
        {
          id: customer?.deliveryDetails?.customerId || 'new',
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Polygon',
            coordinates: [JSON.parse(customerGeoFencing)]
          }
        }
      ]
    : [];
};

export const isLocationWithinGeoFence = (geoFence, location) => {
  if (!geoFence || geoFence.length === 0 || !Boolean(location)) {
    return true;
  }
  const mapBounds = polygon([[...geoFence]]);
  const point = points([[location.longitude, location.latitude]]);
  const value = pointsWithinPolygon(point, mapBounds);
  return Boolean(value.features.length)
};
